import React, { Component } from "react";
import CartContext from "./CartContext";
import {
  Modal,
  Form,
  Row,
  Col,
  Table,
  Button,
  OverlayTrigger,
  Tooltip,
  Accordion,
  Card,
} from "react-bootstrap";
import Switch from "react-switch";
import { LoadSpinner } from "./LoadSpinner";
import { MessageBox } from "./MessageBox";

export class CategoryAddOrEditModal extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);

    this.state = {
      name: this.props.ModalType === "Edit" ? this.props.maincategory.name : "",
      description:
        this.props.ModalType === "Edit"
          ? this.props.maincategory.description
          : "",
      hideMe:
        this.props.ModalType === "Edit"
          ? this.props.maincategory.hideMe
          : false,
      imgFileName:
        this.props.ModalType === "Edit"
          ? this.props.maincategory.imgFileName
          : "",
      adImgFileName:
        this.props.ModalType === "Edit"
          ? this.props.maincategory.adImgFileName
          : "",
      subCategoryArray:
        this.props.ModalType === "Edit"
          ? this.props.subCategories || []
          : [
              {
                name: "",
                storeId: this.props.storeId,
                description: "",
                hideMe: false,
                imgFileName: "",
              },
            ],
      loadSpinnerOpen: false,
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
    };
  }

  ShowLoadSpinner = () => this.setState({ loadSpinnerOpen: true });
  HideLoadSpinner = () => this.setState({ loadSpinnerOpen: false });

  ShowMessagBox = (title, message) =>
    this.setState({
      msgboxOpen: true,
      msgboxTitle: title,
      msgboxMessage: message,
    });

  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
    this.props.onHide();
  };

  OnNameChange = (event) => this.setState({ name: event.target.value });
  OnDescriptionChange = (event) =>
    this.setState({ description: event.target.value });
  OnMainCategoryImgNameChanges = (e) =>
    this.setState({ imgFileName: e.target.value });
  OnMainCategoryAdImgNameChanges = (e) =>
    this.setState({ adImgFileName: e.target.value });

  handleSubCategoryAdd = (e) => {
    this.setState((s) => ({
      subCategoryArray: [
        ...s.subCategoryArray,
        {
          name: "",
          storeId: this.props.storeId,
          description: "",
          hideMe: false,
          imgFileName: "",
        },
      ],
    }));
  };

  handleSubCategoryControlChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...this.state.subCategoryArray];
    list[index][name] = value;
    this.setState({ subCategoryArray: list });
  };

  handleSubCategoryHidemeChange = (val, index) => {
    const list = [...this.state.subCategoryArray];
    list[index]["hideMe"] = !val;
    this.setState({ subCategoryArray: list });
  };

  handleSubCategoryImageFileNameChange = (e, index) => {
    const list = [...this.state.subCategoryArray];
    list[index]["imgFileName"] = e.target.value;
    this.setState({ subCategoryArray: list });
  };

  handleRemoveSubCategoryClick = (i) => {
    const list = [...this.state.subCategoryArray];
    list.splice(i, 1);
    this.setState({ subCategoryArray: list });
  };

  AddCategoryToDB = () => {
    this.ShowLoadSpinner();
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        storeId: this.context.storeId,
        name: this.state.name,
        description: this.state.description,
        imgFileName: this.state.imgFileName,
        adImgFileName: this.state.adImgFileName,
        hideMe: this.state.hideMe,
        subCategories: this.state.subCategoryArray,
      }),
    };

    fetch(
      process.env.REACT_APP_API + "StoreManager/AddMainCategory/",
      requestOptions
    )
      .then((res) => {
        this.HideLoadSpinner();
        if (res.status === 200) {
          this.context.getMainCategories();
          this.context.getSubCategories();
          this.ShowMessagBox(
            "Status",
            "Saved Successfully! Click Refresh button to see the changes."
          );
          return;
        }
        alert("not updated");
      })
      .catch((error) => {
        this.HideLoadSpinner();
        alert("Failed: " + error);
      });
  };

  UpdateCategoryToDB = () => {
    this.ShowLoadSpinner();
    const tmpMainCategory = { ...this.props.maincategory };
    tmpMainCategory.name = this.state.name;
    tmpMainCategory.hideMe = this.state.hideMe;
    tmpMainCategory.description = this.state.description;
    tmpMainCategory.imgFileName = this.state.imgFileName;
    tmpMainCategory.adImgFileName = this.state.adImgFileName;
    tmpMainCategory.subCategories = this.state.subCategoryArray;

    const requestOptions = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(tmpMainCategory),
    };

    fetch(
      process.env.REACT_APP_API +
        "StoreManager/UpdateMainCategory/" +
        this.props.maincategory.id,
      requestOptions
    )
      .then((res) => {
        this.HideLoadSpinner();
        if (res.status === 200) {
          this.context.getMainCategories();
          this.context.getSubCategories();
          this.ShowMessagBox(
            "Status",
            "Updated Successfully. Click Refresh Button to see the changes!"
          );
          return;
        }
        alert("not updated");
      })
      .catch((error) => {
        this.HideLoadSpinner();
        alert("Failed: " + error);
      });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    if (this.props.ModalType === "Edit") this.UpdateCategoryToDB();
    else this.AddCategoryToDB();
  };

  handleMainCategoryHidemeChange = (checked) => {
    this.setState({ hideMe: !checked });
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  // --- UI helpers: desktop table for subcategories, mobile accordion/cards for subcategories
  renderSubcategoriesDesktop() {
    return (
      <Table bordered striped size="sm" className="my-2 text-center">
        <thead className="bg-secondary text-white">
          <tr>
            <td width="20%">Sub Category Name</td>
            <td width="30%">Description</td>
            <td width="20%">Image File Name</td>
            <td width="10%">Image</td>
            <td width="10%">Show Me</td>
            <td width="5%"></td>
          </tr>
        </thead>
        <tbody>
          {this.state.subCategoryArray.map((row, i) => (
            <tr key={row.id || i}>
              <td>
                <Form.Control
                  type="text"
                  name="name"
                  value={row.name}
                  required
                  onChange={(e) => this.handleSubCategoryControlChange(e, i)}
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  name="description"
                  value={row.description}
                  onChange={(e) => this.handleSubCategoryControlChange(e, i)}
                />
              </td>
              <td className="text-start">
                <Form.Select
                  value={row.imgFileName}
                  onChange={(e) =>
                    this.handleSubCategoryImageFileNameChange(e, i)
                  }
                >
                  <option value=""></option>
                  {this.context.images.map((r) => (
                    <option key={r.name} value={r.name}>
                      {r.name}
                    </option>
                  ))}
                </Form.Select>
              </td>
              <td>
                <img
                  width="50"
                  height="30"
                  src={
                    this.context.store.storageBlobUrl +
                    this.context.store.storageBlobContainerName +
                    "/images/" +
                    row.imgFileName +
                    this.context.store.storageSasToken
                  }
                  alt=""
                />
              </td>
              <td>
                <Switch
                  height={20}
                  onChange={(val) => this.handleSubCategoryHidemeChange(val, i)}
                  checked={!row.hideMe}
                />
              </td>
              <td>
                <OverlayTrigger overlay={<Tooltip>Delete!</Tooltip>}>
                  <Button
                    variant="outline-primary"
                    onClick={() => this.handleRemoveSubCategoryClick(i)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-trash"
                      viewBox="0 0 16 16"
                    >
                      <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                      <path
                        fillRule="evenodd"
                        d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                      />
                    </svg>
                  </Button>
                </OverlayTrigger>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  }

  renderSubcategoriesMobile() {
    return (
      <Accordion
        defaultActiveKey={this.state.subCategoryArray.length ? "0" : null}
        className="d-block d-md-none"
      >
        {this.state.subCategoryArray.map((row, i) => (
          <Card key={row.id || i} className="mb-2">
            <Accordion.Item eventKey={String(i)}>
              <Accordion.Header>
                <div className="d-flex justify-content-between w-100">
                  <div style={{ fontWeight: 600 }}>
                    {row.name || "New Subcategory"}
                  </div>
                  <div style={{ fontSize: 12 }}>Seq: {row.seqNo || "-"}</div>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <Form.Group className="mb-2">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    name="name"
                    value={row.name}
                    onChange={(e) => this.handleSubCategoryControlChange(e, i)}
                  />
                </Form.Group>

                <Form.Group className="mb-2">
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    name="description"
                    value={row.description}
                    onChange={(e) => this.handleSubCategoryControlChange(e, i)}
                  />
                </Form.Group>

                <Form.Group className="mb-2">
                  <Form.Label>Image</Form.Label>
                  <Form.Select
                    value={row.imgFileName}
                    onChange={(e) =>
                      this.handleSubCategoryImageFileNameChange(e, i)
                    }
                  >
                    <option value=""></option>
                    {this.context.images.map((r) => (
                      <option key={r.name} value={r.name}>
                        {r.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <small>Visible</small>
                    <div>
                      <Switch
                        height={18}
                        onChange={(val) =>
                          this.handleSubCategoryHidemeChange(val, i)
                        }
                        checked={!row.hideMe}
                      />
                    </div>
                  </div>

                  <div>
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => this.handleRemoveSubCategoryClick(i)}
                    >
                      Delete
                    </Button>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Card>
        ))}
      </Accordion>
    );
  }

  render() {
    return (
      <div className="container">
        {this.state.msgboxOpen && (
          <MessageBox
            open={this.state.msgboxOpen}
            title={this.state.msgboxTitle}
            message={this.state.msgboxMessage}
            callback={this.CloseMessagBoxCallback}
          />
        )}

        <Modal
          {...this.props}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
          keyboard={false}
          dialogClassName="ProductModal"
          size="lg"
        >
          <Form onSubmit={this.handleSubmit}>
            <Modal.Header closeButton className="bg-warning">
              <Modal.Title id="contained-modal-title-vcenter">
                {this.props.ModalType === "Edit"
                  ? "Edit Category"
                  : "Add Category"}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body className="show-grid">
              <Row>
                <Col className="text-secondary">
                  <h4>Main Category Details</h4>
                </Col>
              </Row>

              <Row className="border bg-light">
                <Col xs={12} md={6} className="my-3">
                  <Row className="mb-2">
                    <Col md={3}>Main Category Name</Col>
                    <Col md={9}>
                      <Form.Control
                        type="text"
                        name="MainCategoryName"
                        value={this.state.name}
                        required
                        onChange={this.OnNameChange}
                      />
                    </Col>
                  </Row>

                  <Row className="mb-2">
                    <Col md={3}>Description</Col>
                    <Col md={9}>
                      <Form.Control
                        type="text"
                        as="textarea"
                        rows={3}
                        name="MainCategoryDescription"
                        maxLength="499"
                        value={this.state.description}
                        onChange={this.OnDescriptionChange}
                      />
                    </Col>
                  </Row>

                  <Row className="mb-2">
                    <Col md={3}>Show Me</Col>
                    <Col md={9}>
                      <div className="my-2">
                        <Switch
                          height={20}
                          onChange={this.handleMainCategoryHidemeChange}
                          checked={!this.state.hideMe}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row className="mb-2">
                    <Col md={3}>Image FileName</Col>
                    <Col md={9}>
                      <Form.Select
                        value={this.state.imgFileName}
                        onChange={this.OnMainCategoryImgNameChanges}
                      >
                        <option value=""></option>
                        {this.context.images.map((r) => (
                          <option key={r.name} value={r.name}>
                            {r.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                  </Row>

                  <Row className="mb-2">
                    <Col md={3}>Ad Image FileName</Col>
                    <Col md={9}>
                      <Form.Select
                        value={this.state.adImgFileName}
                        onChange={this.OnMainCategoryAdImgNameChanges}
                      >
                        <option value=""></option>
                        {this.context.images.map((r) => (
                          <option key={r.name} value={r.name}>
                            {r.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                  </Row>
                </Col>

                <Col xs={12} md={6} className="my-3">
                  <Row>
                    <Col>
                      <Form.Group
                        controlId="Image"
                        className="text-center mb-2"
                      >
                        Category Image
                        <img
                          width="100%"
                          height="200px"
                          style={{ objectFit: "contain" }}
                          src={
                            this.context.store.storageBlobUrl +
                            this.context.store.storageBlobContainerName +
                            "/images/" +
                            this.state.imgFileName +
                            this.context.store.storageSasToken
                          }
                          alt=""
                        />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group
                        controlId="AdImage"
                        className="text-center mb-2"
                      >
                        Ad Image
                        <img
                          width="100%"
                          height="200px"
                          style={{ objectFit: "contain" }}
                          src={
                            this.context.store.storageBlobUrl +
                            this.context.store.storageBlobContainerName +
                            "/images/" +
                            this.state.adImgFileName +
                            this.context.store.storageSasToken
                          }
                          alt=""
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row className="mt-3">
                <Col>
                  <Row>
                    <Col xs={6} md={8} className="text-start text-secondary">
                      <h4>Sub Category Details</h4>
                    </Col>
                    <Col xs={6} md={4} className="text-end">
                      <Button
                        variant="primary"
                        onClick={this.handleSubCategoryAdd}
                      >
                        + Add
                      </Button>
                    </Col>
                  </Row>

                  {/* Desktop table for larger screens */}
                  <div className="d-none d-md-block">
                    {this.renderSubcategoriesDesktop()}
                  </div>

                  {/* Mobile stacked/accordion for small screens */}
                  <div className="d-block d-md-none">
                    {this.renderSubcategoriesMobile()}
                  </div>

                  {this.state.loadSpinnerOpen && <LoadSpinner open="true" />}
                </Col>
              </Row>
            </Modal.Body>

            <Modal.Footer className="bg-light">
              <Form.Group>
                <Button variant="primary" type="submit" size="lg">
                  Save
                </Button>
              </Form.Group>

              <Button variant="danger" size="lg" onClick={this.props.onHide}>
                Close
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    );
  }
}
